import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiEmployeeListView,
  ApiEmployeeListViewCreate,
  ApiEmployeeListViewReorder,
  ApiEmployeeListViewUpdate,
} from "@/types/employees/employee-view.types.ts";

export const apiEmployeeView = {
  getViews: (type: string) => {
    return api.get<ApiEmployeeListView[]>(`/api/v1/employees/views`, { type });
  },
  createView: (body: ApiEmployeeListViewCreate) => {
    return api.post<ApiEmployeeListView>(`/api/v1/employees/views`, body);
  },
  updateView: (viewId: number, body: ApiEmployeeListViewUpdate) => {
    return api.put<ApiEmployeeListView>(`/api/v1/employees/views/${viewId}`, body);
  },
  deleteView: (viewId: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/employees/views/${viewId}`);
  },
  reorderViews: (body: ApiEmployeeListViewReorder) => {
    return api.put<ApiEmployeeListView[]>(`/api/v1/employees/views/reorder`, body);
  },
  setDefaultView: (viewId: number) => {
    return api.put<ApiEmployeeListView[]>(`/api/v1/employees/views/${viewId}/default`, {});
  },
};
